import { render, staticRenderFns } from "./WizardStep6.vue?vue&type=template&id=75e55bff"
import script from "./WizardStep6.vue?vue&type=script&lang=js"
export * from "./WizardStep6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports